//秘鲁站点
export default {
  WebSiteId: 1033,
  SearchType1: false, //搜索栏本地商城
  SearchType2: false, //搜索栏店铺
  seller: false,
  LODAMall: false,
  LODALive: false,
  LodaFood: false,
  LODAAPP: true,
  Applink: false,
  ExpressNotices: true,
  RecommendModular: true,
  Activities: true,
  Mailbox: '',
  lodaDelivery: true,
  AboutUs: true,
  weixin: true,
  invitation: false,
  article: {
    'zh-cn': [
      1160512,
      null,
      1160313,
      1160500,
      1160503,
      1160522,
      1160516,
      1160385,
      1160528,
    ],
    en: [
      1160513,
      null,
      1160320,
      1160501,
      1160504,
      1160523,
      1160517,
      1160498,
      1160529,
    ],
    pe: [
      1160514,
      null,
      1160309,
      1160502,
      1160505,
      1160524,
      1160518,
      1160499,
      1160530,
    ],
  },
  ExternalLogin: true,
  stationLetter: true,
  coupons: true,
  NoEmail: true,
  areaCode: true,
  LODA: 'LODA Peru',
  LODAGoogle: 'https://www.googletagmanager.com/gtag/js?id=G-G7BESTT3N8',
  LODAGoogleCode:
    "window.dataLayer = window.dataLayer || [];function gtag() { dataLayer.push(arguments); }gtag('js', new Date());gtag('config', 'G-G7BESTT3N8');",
  logoPng: 'LODA.png',
  login_banner: 'login_banner_cn.jpg',
  login_bgColor: '#dd5246',
  title:
    'LODA កម្ពុជា - Cambodia Online Shopping Platform | Wholesale & Purchasing, International Shipping & Delivery Express, Food Delivery, Mall',
  keywords:
    'LODA,online shopping,purchasing,wholesale,international shipping,delivery,express,food delivery,marketplace,mall,product,coupons,B2B,B2C,online transactions,shopping,China,Cambodia',
  default_description:
    'LODA Cambodia (loda.com.kh) is the largest online shopping e-commerce platform in Cambodia, providing e-commerce services such as online shopping, wholesale & purchasing, international shipping & delivery express, food delivery, local mall. We offer a wide range of products for you to choose from, and various promotions such as coupons and flash sales to help you save even more.',
  ShowMallType: false,
  symbol: 'PEN ',
  CurrencyCode: 'PEN ',
  separator: ',',
  precision: 2,
  lans: {
    pe: { val: 'pe', name: 'Español' },
    'zh-cn': { val: 'zh-cn', name: '中文' },
    en: { val: 'en', name: 'English' },
  },
  DefaultMapcenter: { lat: -9.19, lng: -75.01515 },
  getPlacePredictions: 'pe',
  translateLan: 'en',
  OrderStatu: [
    { name: '全部订单', StatuId: null },
    { name: '待审核', StatuId: 1 },
    { name: '待付款', StatuId: 2 },
    { name: '订购中', StatuId: 3 },
    { name: '已入库（中国仓）', StatuId: 4 },
    { name: '国际运输中', StatuId: 5 },
    { name: '已入库（本地仓）', StatuId: 6 },
    { name: '待收货', StatuId: 7 },
    { name: '已完成', StatuId: 8 },
    { name: '取消', StatuId: 9 },
    { name: '售后', StatuId: 20 },
  ],
  sources: [
    { name: '全部', val: null },
    { name: '海外购', val: '5' },
  ],
  WorkingHours1_5: '09:00-18:00',
  WorkingHours6_7: '08:00-17:00',
}
